<template>
  <el-contianer>



  <div>
    <el-container>
      <el-row style="width: 98%;">
        <el-col :span="20">
          <el-container>
            <el-col :span="4" :offset="6"><el-input v-model="SunitName" placeholder="根据公司名称查询"></el-input></el-col>

			<el-col :span="4" :offset="1">

				 <el-date-picker
				      v-model="value1"
				      type="daterange"
				      range-separator="至"
				      start-placeholder="开始日期"
				      end-placeholder="结束日期">
				    </el-date-picker>
			</el-col>
            <el-col :span="5" :offset="2"><el-button type="primary" @click="select()">点击查询</el-button></el-col>
          </el-container>

        </el-col>

        <el-col :span="2" :offset="1">
          <el-button type="primary" @click="dialogFormVisible = true">添加单位</el-button>
          <el-dialog title="添加单位" :visible.sync="dialogFormVisible" width="35%">
            <el-form>
              <el-form-item label="单位名称">
                <el-input v-model="unitName"></el-input>
              </el-form-item>
              <el-form-item label="单位描述">
                <el-input v-model="unitDetail"></el-input>
              </el-form-item>



            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="dialogFormVisible = false;add()">确 定</el-button>
            </div>
          </el-dialog>
        </el-col>
      </el-row>
    </el-container>








  </div>
    <el-table
        :data="tableData"
        style="width: 100%;margin-top: 1%;">
        <el-table-column
          prop="unitName"
          label="单位名称"
          width="250">
        </el-table-column>

        <el-table-column
          prop="unitDetail"
          label="单位描述"
          width="180">
        </el-table-column>


<!--        <el-table-column
          prop="mgr"
          label="上级单位Id"
          width="180">
        </el-table-column> -->

        <el-table-column
          prop="mgrName"
          label="上级单位名称"
          width="180">
        </el-table-column>



        <el-table-column
          label="创建时间"
          width="180">
          <template slot-scope="scope">
          {{ formattedTime(scope.row.createDate) }}</template>
        </el-table-column>



        <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="dialogFormEdit = true;EditData(scope.row)">编辑</el-button>

                  <el-dialog title="单位信息修改" :visible.sync="dialogFormEdit" width="35%">
                    <el-form>
                      <el-form-item label="单位ID">
                        <el-input :disabled="true" v-model="EunitId"></el-input>
                      </el-form-item>


                      <el-form-item label="单位名称">
                        <el-input v-model="EunitName"></el-input>
                      </el-form-item>
                      <el-form-item label="单位描述">
                        <el-input v-model="EunitDetail"></el-input>
                      </el-form-item>

                     <!-- <el-form-item label="一级单位选择">
                        <el-switch
                          v-model="value"
                          active-color="#13ce66"
                          inactive-color="#ff4949">
                          一级单位
                        </el-switch>
                      </el-form-item>

                      <el-form-item label="二级单位选择" v-if="value == false">
                        <el-select v-model.trim="EMgr" placeholder="选择二级单位">
                            <el-option
                            v-for="i in MgrData"
                            :key="i.id"
                            :label="i.label"
                            :value="i.id">
                            </el-option>
                        </el-select>
                      </el-form-item> -->


                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">取 消</el-button>
                      <el-button type="primary" @click="dialogFormEdit = false;handleEdit(scope.$index, scope.row)">确 定</el-button>
                    </div>
                  </el-dialog>

               <!-- <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                  <el-button
                  size="mini"
                  @click="toCategory(scope.row)">查看此部门</el-button>
              </template>
            </el-table-column>

      </el-table>
      <div class="block">
          <el-pagination
               @size-change="handleSizeChange"
               @current-change="select"
               :current-page="currentPage"
               :page-sizes="[10, 20, 50, 100]"
               :page-size="pageSize"
               layout="total, sizes, prev, pager, next, jumper"
               :total="total">
             </el-pagination>
        </div>
  </div>
  </el-contianer>
</template>

<script>
  import axios from 'axios'
  import Cookies from "js-cookie";
  export default {
     name: 'Unit',
     data () {
       return {
         currentPage: 1,
         pageSize:20,
				 total:0,
        dialogFormVisible: false,
        dialogFormEdit: false,
        SunitName:'',
        SstartDate:'',
        SendDate:'',
        unitName:'',
        unitDetail:'',
        MgrData:[{
          id:'',
          label:''
        }],

        EunitId:'',
        EunitName:'',
        EunitDetail:'',
        EMgr:'',
        value1: '',
        tableData: [{
                unitId:'',
                unitName:'',
                unitDetail:'',
                createDate:'',
                mgr:'',
                del:'',
                mgrName:''
              }],
			}
       },
     created:function() {
       this.showData();
       this.showMgrData();
     },
     methods: {
      toCategory(scope) {
        console.log(scope.unitId)
        localStorage.setItem('searchUnitId',scope.unitId)
        this.$router.push({
          path: '/Department',
          // query: {
          //   unitId: scope.unitId
          // }
        })
      },
      formattedTime(val) {
              const date = new Date(val);
              const year = date.getFullYear();
              const month = ("0" + (date.getMonth() + 1)).slice(-2);
              const day = ("0" + date.getDate()).slice(-2);
              return `${year}-${month}-${day} `;
            },
      EditData(rows) {
          this.EunitId = rows.unitId,
          this.EunitName = rows.unitName,
          this.EunitDetail = rows.unitDetail

           },


       showData(){
        var authorization = Cookies.get("Authorization");
        var params = {
          currentPage: 1,
          pageSize: 10,
        }
         this.axios({
             method: 'GET',
             url: '/unit/showUnits',
             params:params,
             header:{
              // 'Authorization':authorization,
             	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
             	}
           }).then((resp)=>{
            this.tableData=resp.data.data;
            this.total = resp.data.count;
           })
       },


		handleSizeChange(val){
				 this.pageSize = val
				 this.select()
		},


         select(val){
            var authorization = Cookies.get("Authorization");
            this.currentPage = val
            var paramsData = {
              currentPage: val || 1 || undefined,
              pageSize: this.pageSize,
              unitName:this.SunitName || undefined,
              endDate:this.value1[1] || undefined,
              startDate:this.value1[0] || undefined ,
            }
             this.axios({
                 method: 'GET',
                 url: '/unit/showUnits',
                 params:paramsData,
                 header:{
                  'Authorization':authorization,
                 	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                 	}
               }).then((resp)=>{
                  this.tableData=resp.data.data;
                  this.total = resp.data.count;
               })
         },

         add(){
           var authorization = Cookies.get("Authorization");
           this.axios({
               method: 'POST',
               url: '/unit/addUnit',
               data: {
                 unitName:this.unitName,
                 unitDetail:this.unitDetail,

               },  //这里json对象会转换成json格式字符串发送

               header:{
                'Authorization':authorization,
               	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
               	}
             }).then((resp)=>{
                    if(resp.data.code == 200){
                      this.open3(resp.data.message)
                    }else{
                      this.open2(resp.data.message)
                    }
                    this.select(this.currentPage)
               })
         },
         handleEdit(index, row) {
              var authorization = Cookies.get("Authorization");
              this.axios({
                  method: 'POST',
                  url: '/unit/updateUnit',
                  data:{
                    unitId:this.EunitId,
                    unitName:this.EunitName,
                    unitDetail:this.EunitDetail,
                    del:row.del,
                    mgr:this.EunitId
                  },
                  header:{
                   'Authorization':authorization,
                  	'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                  	}
                }).then((resp)=>{
                    if(resp.data.code == 200){
                      this.open3(resp.data.message)
                    }else{
                      this.open2(resp.data.message)
                    }
                    this.select(this.currentPage)
               })
              },




              handleDelete(index, row) {
                var authorization = Cookies.get("Authorization");
                this.axios({
                    method: 'POST',
                    url: '/unit/deleteUnit',
                    params:{
                      ids:row.unitId
                    },
                    header:{
                     'Authorization':authorization,
					'Content-Type':'application/json;charset=UTF-8'  //如果写成contentType会报错,如果不写这条也报错
                    	}
                  }).then((resp)=>{
                    if(resp.data.code == 200){
                      this.open3(resp.data.message)
                    }else{
                      this.open2(resp.data.message)
                    }
                    this.select(this.currentPage)

               })
              },
              open2(val) {
                      this.$message({
                        message: val,
                        type: 'warning',
						duration: 3000
                      });
                    },
              open3(val) {
                     this.$message({
                       message: val,
                       type: 'success',
						duration: 3000
                     });
                   },
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Munber/Unit.vue